import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useSelector } from "react-redux";
import "./newUser.css";
import firebase, { storage } from "../../config/firebase";
import { ref, getDownloadURL, uploadBytesResumable, } from "firebase/storage";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import Radio from "@mui/material/Radio";
import { AutoComplete, Input } from 'antd';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputMask from "react-input-mask";
import BackButton from "../../components/backButton/BackButton";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { Button, Card } from "@mui/material";
import Permissions from "../../components/permission";
import CreateListPerfil from "../perfil/CreateListPerfil";
import perfilService from "../../service/perfil.service";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import TransferList from "../../components/TransferList/transferList";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// Função para comparar objetos de permissões de forma profunda
function comparePermissoes(obj1, obj2) {
    // Se os tipos são diferentes, não são iguais
    if (typeof obj1 !== typeof obj2) return false;
    
    // Se não são objetos ou são null, compara diretamente
    if (typeof obj1 !== 'object' || obj1 === null || obj2 === null) {
        return obj1 === obj2;
    }
    
    // Compara as chaves
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    
    // Para cada chave, compara os valores recursivamente
    return keys1.every(key => {
        if (!obj2.hasOwnProperty(key)) return false;
        return comparePermissoes(obj1[key], obj2[key]);
    });
}

require("firebase/auth");

const INITIAL_PERMISSOES = {
    freight: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    client: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    driver: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    shipper: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    user: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    mdfe: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    import: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    payment: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    tableIcms: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    ocurrence: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    tablePrice: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    accompaniment: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    perfil: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
};

function mergePermissoesFrom(source = {}, fallback = INITIAL_PERMISSOES) {
    const result = {};
    for (const key of Object.keys(fallback)) {
        const maybe = source?.[key] ?? {};
        result[key] = {
            selecionarTodos: maybe?.selecionarTodos ?? false,
            isView: maybe?.isView ?? false,
            isCreate: maybe?.isCreate ?? false,
            isEdit: maybe?.isEdit ?? false,
            isDelete: maybe?.isDelete ?? false,
        };
    }
    return result;
}

function NewUser() {
    const { id } = useParams();
    const navigate = useNavigate();
    const user = useSelector((s) => s.user);
    const location = useLocation();

    const [view, setOnlyView] = useState(location.state?.viewOnly || false);

    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [senha2, setSenha2] = useState("");
    const [perfil, setPerfil] = useState("personalizado");
    const [name, setName] = useState("");
    const [cpf, setCpf] = useState("");
    const [shippers, setShippers] = useState([]);
    const [selectedShippers, setSelectedShippers] = useState([]);
    const [shipper, setShipper] = useState(user.uidShipper || "0");
    const [viewALL, setViewALL] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [ativo, setAtivo] = useState("");
    const [image, setImage] = useState("");
    const [file, setFile] = useState(null);

    const [msgTipo, setMsgTipo] = useState();
    const [carregando, setCarregando] = useState(false);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState();
    const [title, setTitle] = useState();
    const [perfilList, setPerfilList] = useState([]);
    const [perfilSelect, setPerfilSelecionado] = useState(null);

    const [permissoes, setPermissoes] = useState(INITIAL_PERMISSOES);
    const [selecionarTodosGeral, setSelecionarTodosGeral] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [isLoadingUser, setIsLoadingUser] = useState(false);

    const [listUser, setListUser] = useState([]);

    const [viewer, setViewer] = useState(false);

    // 🔹 Armazena o estado anterior das permissões do perfil selecionado (declarado cedo para uso durante o carregamento de usuário)
    const perfilPermissoesRef = useRef(INITIAL_PERMISSOES);
    const [comparEPermissoes, setComparePermissoes] = useState([]);

    // helpers
    const calcularSelecionarTodosGeral = useCallback((state) => {
        return Object.values(state).every((g) => g.selecionarTodos);
    }, []);

    const handleChangeCheckbox = (event) => {
        setViewALL(event.target.checked);
    }
    
    const handleChange = useCallback((grupo, campo) => {
        setPermissoes((prev) => {
            const novo = { ...prev };
            if (campo === "selecionarTodos") {
                const novoValor = !prev[grupo].selecionarTodos;
                novo[grupo] = {
                    selecionarTodos: novoValor,
                    isView: novoValor,
                    isCreate: novoValor,
                    isEdit: novoValor,
                    isDelete: novoValor,
                };
            } else {
                novo[grupo] = {
                    ...prev[grupo],
                    [campo]: !prev[grupo][campo],
                };
                const g = novo[grupo];
                novo[grupo].selecionarTodos = g.isView && g.isCreate && g.isEdit && g.isDelete;
            }

            setSelecionarTodosGeral(calcularSelecionarTodosGeral(novo));
            return novo;
        });
    }, [calcularSelecionarTodosGeral]);

    const handleSelecionarTodosGeral = useCallback(() => {
        setPermissoes((prev) => {
            const novoValor = !selecionarTodosGeral;
            const novo = {};
            for (const k of Object.keys(prev)) {
                novo[k] = {
                    selecionarTodos: novoValor,
                    isView: novoValor,
                    isCreate: novoValor,
                    isEdit: novoValor,
                    isDelete: novoValor,
                };
            }
            setSelecionarTodosGeral(novoValor);
            return novo;
        });
    }, [selecionarTodosGeral]);

    // image upload returns URL
    const uploadImage = useCallback(
        async (fileToUpload) => {
            if (!fileToUpload) return null;
            try {
                const storageRef = ref(storage, `files/user/${cpf || "unknown"}`);
                await uploadBytesResumable(storageRef, fileToUpload);
                const url = await getDownloadURL(storageRef);
                setImage(url);
                return url;
            } catch (err) {
                console.error("Erro upload imagem:", err);
                return null;
            }
        },
        [cpf]
    );

    async function loadImage(filePath) {
        try {
            const fileRef = ref(storage, filePath);
            const url = await getDownloadURL(fileRef);
            setImage(url);
        } catch (err) {
            console.error("Erro ao buscar imagem:", err);
        }
    }

    const fetchPerfil = async () => {
        const list = await perfilService.getPerfis();
        if (!list) return console.error("Erro na busca de dados de perfil!");
        setPerfilList(list);

        const snapshot = await firebase.firestore().collection("user_web").get();
        if (!listUser) return console.error("Erro na busca de dados de usuário!");
        const users = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setListUser(users);
    };

    function isAllPermissoesFalse(permissoesObj) {
        return Object.values(permissoesObj).every(g =>
            !g?.selecionarTodos && !g?.isView && !g?.isCreate && !g?.isEdit && !g?.isDelete
        );
    }

    // fetch shippers & perfis once
    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setCarregando(true);
            try {
                await fetchPerfil();
                
                // Lógica para carregar shippers
                if (user.viewALL) {
                    const snapshot = await firebase.firestore().collection("shipper").get();
                    if (!mounted) return;
                    setShippers(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
                } else {
                    // Coleta todos os UIDs possíveis sem aninhamento
                    const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
                    const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
                    const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

                    if (uids.length > 0) {
                        const shipperPromises = uids.map((uid) =>
                            firebase.firestore().collection("shipper").doc(uid).get()
                        );
                        const shipperDocs = await Promise.all(shipperPromises);
                        if (!mounted) return;
                        const shipperData = shipperDocs
                            .filter((doc) => doc.exists)
                            .map((doc) => ({ id: doc.id, ...doc.data() }));
                        setShippers(shipperData);
                    } else {
                        setShippers([]);
                    }
                }

                // Carregar dados do usuário se houver ID
                if (id) {
                    setIsLoadingUser(true);

                    const doc = await firebase.firestore().collection("user_web").doc(id).get();
                    const userData = doc.data() || {};
                    
                    if (!mounted) return;

                    setName(userData.name ?? "");
                    setCpf(userData.cpf ?? "");
                    setEmail(userData.email ?? "");
                    setPhoneNumber(userData.phoneNumber ?? "");
                    setPerfil(userData?.perfil);
                    setShipper(userData?.uidShipper || "0");
                    // Corrigido: não envolve array em outro array
                    setSelectedShippers(Array.isArray(userData?.uidShipperAffiliates) ? userData.uidShipperAffiliates : []);
                    setAtivo(userData.ativo ?? "");
                    setViewALL(userData.viewALL);
                    setPermissoes(mergePermissoesFrom(userData.permissoes));
                    setComparePermissoes(mergePermissoesFrom(userData.permissoes));
                    setSelecionarTodosGeral(userData.permissoesAll ?? userData.selecionarTodosGeral ?? false);

                    if (userData.file) {
                        await loadImage(userData.file);
                    }

                    setIsLoadingUser(false);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setCarregando(false);
            }
        };

        load();
        return () => {
            mounted = false;
        };
    }, [id, user]);

    // 🔹 Quando o perfil muda, atualiza permissões e guarda referência
    useEffect(() => {
        if (!perfil || perfil === "personalizado") return;

        // fetchPerfil();

        const perfilSelecionado = perfilList.find((p) => p.nomePerfil === perfil);
        if (!perfilSelecionado) return;

        const novasPermissoes = mergePermissoesFrom(perfilSelecionado.permissoes);
        setPermissoes(novasPermissoes);
        setSelecionarTodosGeral(perfilSelecionado.selecionarTodosGeral || false);
        setPerfilSelecionado(perfilSelecionado);
        setComparePermissoes(novasPermissoes);

    }, [perfil, perfilList]);

    // 🔹 Detecta quando as permissões mudarem e forem diferentes das do perfil atual
    useEffect(() => {
        if (isLoadingUser) return;
        if (!perfil || perfil === "personalizado") return;
        if (!user?.permissoes?.user?.isView) return;

        const permissoesSaoDiferentes = !comparePermissoes(permissoes, comparEPermissoes);

        if (permissoesSaoDiferentes) {
            if (isAllPermissoesFalse(permissoes)) {
                return;
            }
            else {
                console.log("Permissões modificadas - mudando para personalizado");
                setPerfil("personalizado");
            }
        }
    }, [permissoes, comparEPermissoes, perfil, isLoadingUser, user?.permissoes?.user?.isView]);

    // handlers
    const handleStatus = (e) => setAtivo(e.target.value);

    const handleImageChange = async (e) => {
        const f = e.target.files?.[0];
        if (f) {
            setFile(f);
            await uploadImage(f);
        }
    };

    const handleClose = () => setOpen(false);

    const validateRequired = () => {
        const missing = [];

        if (!email) missing.push("E-mail");
        if (!id && !senha) missing.push("Senha");
        if (!name) missing.push("Nome");
        if (!cpf) missing.push("CPF");
        if (!phoneNumber) missing.push("Telefone");
        if (!ativo) missing.push("Status (Ativo ou Inativo)");
        
        if (missing.length > 0) {
            setMsgTipo("erro");
            setMsg(`Todos os campos são de preenchimento obrigatório: ${missing.join(", ")}`);
            setTitle("Oops!");
            setOpen(true);
            return false;
        }
        if (shipper === "0") {
            setMsgTipo("erro");
            setMsg("Por favor, escolha um Embarcador válido");
            setTitle("Oops!");
            setOpen(true);
            return false;
        }
        return true;
    };

    const save = async () => {
        setCarregando(true);
        try {
            if (!validateRequired()) return;

            if (senha.length < 6) {
                setMsgTipo("erro");
                setMsg("A senha deve ter pelo menos 6 caracteres");
                setTitle("Oops!");
                setOpen(true);
                return;
            }

            if (senha !== senha2) {
                setMsgTipo("erro");
                setMsg("Senha diferente da confirmação, por favor tente novamente.");
                setTitle("Oops!");
                setOpen(true);
                return;
            }

            if (file) {
                await uploadImage(file);
            }

            const resultado = await firebase.auth().createUserWithEmailAndPassword(email, senha);
            const uid = resultado.user.uid;
            const dataUser = {
                uid,
                email: resultado.user.email,
                perfil,
                name,
                cpf,
                ativo,
                phoneNumber,
                accountCreated: new Date(),
                uidShipper: shipper,
                uidShipperAffiliates: selectedShippers,
                viewALL: viewALL || false,
                permissoes,
                permissoesAll: selecionarTodosGeral,
                file: image,
            };

            await firebase.firestore().collection("user_web").add(dataUser);
            setMsgTipo("sucesso");
            navigate("/userList");
        } catch (error) {
            setMsgTipo("erro");
            const err = (error?.message || "").toString();
            if (err.includes("weak-password")) setMsg("A senha deve ter pelo menos 6 caracteres");
            else if (err.includes("email-already-in-use")) setMsg("Este e-mail já está sendo utilizado por outro usuário");
            else if (err.includes("invalid-email")) setMsg("O formato do seu e-mail é inválido!");
            else setMsg("Não foi possível cadastrar. Tente novamente mais tarde ou contate o administrador!");
            setTitle("Oops!");
            setOpen(true);
        } finally {
            setCarregando(false);
        }
    };

    const update = async () => {
        setCarregando(true);
        try {
            if (!validateRequired()) return;

            if (senha && senha.length < 6) {
                setMsgTipo("erro");
                setMsg("A senha deve ter pelo menos 6 caracteres");
                setTitle("Oops!");
                setOpen(true);
                return;
            }

            if (senha && senha !== senha2) {
                setMsgTipo("erro");
                setMsg("Senha diferente da confirmação, por favor tente novamente.");
                setTitle("Oops!");
                setOpen(true);
                return;
            }

            if (senha) {
                try {
                    const currentUser = firebase.auth().currentUser;
                    if (currentUser) await currentUser.updatePassword(senha);
                } catch (err) {
                    console.error(err);
                    setMsgTipo("erro");
                    setMsg(
                        err.message && err.message.includes("requires-recent-login")
                            ? "Essa operação é sensível e requer autenticação recente. Faça login novamente."
                            : "Não foi possível alterar a senha. Tente novamente."
                    );
                    setTitle("Oops!");
                    setOpen(true);
                    return;
                }
            }

            if (file) {
                await uploadImage(file);
            }

            const dataUser = {
                email,
                perfil,
                name,
                cpf,
                ativo,
                phoneNumber,
                accountUpdate: new Date(),
                uidShipper: shipper,
                uidShipperAffiliates: selectedShippers,
                viewALL: viewALL || false,
                permissoes,
                permissoesAll: selecionarTodosGeral,
                file: image,
            };

            await firebase.firestore().collection("user_web").doc(id).update(dataUser);
            setMsgTipo("sucesso");
            navigate("/userList");
        } catch (error) {
            console.error(error);
            setMsgTipo("erro");
            setMsg("Não foi possível atualizar. Tente novamente.");
            setTitle("Oops!");
            setOpen(true);
        } finally {
            setCarregando(false);
        }
    };

    const perfilOptions = useMemo(() => {
        return perfilList?.map((p) => (
            <option key={p.id} value={p.nomePerfil}>
                {p.nomePerfil}
            </option>
        ));
    }, [perfilList]);

    const userOptions = useMemo(() => {
        // opções formatadas para Autocomplete
        return listUser?.map((u) => ({
            key: u.id,
            label: `${u.name} (${u.perfil})`,
            perfil: u.perfil,
            raw: u,
        })) || [];
    }, [listUser]);

    return (
        <>
            <NewMiniDrawer
                divOpen={
                    <div className="new-user-page">
                        <div className="head">
                            <h1>Sistema de Cadastro de Usuário</h1>
                            <p>Preencha os dados para cadastrar ou atualizar usuários com clareza.</p>
                        </div>

                        <div className="body">
                            <div className="bodyHead">
                                <div className="bodyHeadLeft">
                                    <div>
                                        <label htmlFor="upload-avatar">
                                            <div
                                                className="logoPerfil"
                                                style={{
                                                    width: "240px",
                                                    height: "240px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#ccc",
                                                    overflow: "hidden",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                {image ? (
                                                    <img src={image} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
                                                ) : (
                                                    <span style={{ fontSize: "24px", color: "#fff" }}>+</span>
                                                )}
                                            </div>
                                            <div>
                                                {image ? (
                                                    <DeleteIcon disabled={view} className="deleteIconUser" onClick={(e) => { e.stopPropagation(); setImage(""); setFile(""); }} />
                                                ): null}
                                            </div>
                                        </label>
                                        <input disabled={view} id="upload-avatar" type="file" accept="image/*" onChange={handleImageChange} style={{ display: "none" }} />
                                    </div>

                                    <div>
                                        <h3>{name || "Novo Nome"}</h3>
                                    </div>
                                </div>

                                <div className="bodyHeadRight">
                                    <form>
                                        <h4 className="sectionTitle">Dados principais</h4>
                                        <div>
                                            <div className="row">
                                                <div className="rowAtivoInativo">
                                                    <div className="radioAtivo">
                                                        <Radio disabled={view} checked={ativo === "Ativo"} onChange={handleStatus} value="Ativo" name="radio-buttons" />
                                                        <label htmlFor="btnradio1">Ativo</label>
                                                        <Radio disabled={view} checked={ativo === "Inativo"} onChange={handleStatus} value="Inativo" name="radio-buttons" />
                                                        <label htmlFor="btnradio2">Inativo</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div>
                                                    <input disabled={view} onChange={(e) => setName(e.target.value)} type="text" value={name || ""} className="form-control" placeholder="Nome" />
                                                </div>
                                                <div>
                                                    <InputMask disabled={view} mask="999.999.999-99" placeholder="CPF" value={cpf || ""} className="form-control" onChange={(e) => setCpf(e.target.value)} />
                                                </div>
                                                <div>
                                                    <InputMask disabled={view} mask="(99) 99999-9999" placeholder="Telefone" value={phoneNumber || ""} className="form-control" onChange={(e) => setPhoneNumber(e.target.value)} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div>
                                                    <input onChange={(e) => setEmail(e.target.value)} disabled={!!id || view} value={email || ""} type="email" className="form-control" placeholder="E-mail" />
                                                </div>

                                                <div className="rowPassword">
                                                    <div className="password">
                                                        <input disabled={view} onChange={(e) => setSenha(e.target.value)} type="password" className="form-control" placeholder="Senha" />
                                                    </div>
                                                    <div className="confirmPassword">
                                                        <input disabled={view} onChange={(e) => setSenha2(e.target.value)} type="password" className="form-control" placeholder="Repetir a senha" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <select disabled={view} className="form-select" id="companyShipper" value={shipper || "0"} onChange={(e) => setShipper(e.target.value)} aria-label="">
                                                    <option value="0">Embarcadora</option>
                                                    {shippers.map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.dataPersonal?.socialName || item.socialName || item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="row">
                                                <FormGroup>
                                                    <FormControlLabel control={<Checkbox disabled={view} checked={viewALL} onChange={handleChangeCheckbox} color="primary" />} label="Visualiza Todos os Embarcadores" />
                                                </FormGroup>
                                            </div>
                                            <div className="row">
                                                {
                                                    viewALL ? null : (
                                                        <TransferList 
                                                            disabled={view}
                                                            shippers={shippers}
                                                            selectedShippers={selectedShippers}
                                                            shipper={shipper}
                                                            onChange={(selected) => setSelectedShippers(selected)}
                                                        />
                                                    )
                                                }
                                            </div>

                                            <div className="rowPerfil">
                                                <div id="autoComplete" className="col-8">
                                                    <AutoComplete
                                                        disabled={view}
                                                        style={{ width: '100%', height: '38px', color: '#000' }}
                                                        options={userOptions.map((user) => ({
                                                            value: user.label,
                                                            perfil: user.perfil,
                                                        }))}
                                                        filterOption={(inputValue, option) =>
                                                            option?.value.toLowerCase().includes(inputValue.toLowerCase())
                                                        }
                                                        onSelect={(value, option) => {
                                                            setPerfil(option?.perfil || 'personalizado');
                                                        }}
                                                        onClear={() => setPerfil('personalizado')}
                                                        allowClear
                                                    >
                                                        <Input
                                                            disabled={view}
                                                            className="autoComplete"
                                                            placeholder="Selecione o Usuário"
                                                            style={{
                                                                height: '38px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #c9c9c9ff',
                                                                fontSize: '14px',
                                                            }}
                                                        />
                                                    </AutoComplete>
                                                </div>
                                                <div id="col-8" className="col-8">
                                                    <select
                                                        disabled={view}
                                                        className="form-select"
                                                        id="formPerfil"
                                                        value={perfil || "personalizado"}
                                                        onChange={(e) => {
                                                            if (e.target.value === "criar") {
                                                                navigate("/createPerfil");
                                                                setPerfil("personalizado");
                                                            } else {
                                                                setPerfil(e.target.value);
                                                            }
                                                        }}
                                                        aria-label=""
                                                    >
                                                        <option value="personalizado"> Personalizado </option>
                                                        {perfilOptions}
                                                        <option value="criar">Criar Perfil</option>
                                                    </select>

                                                    {
                                                        user?.permissoes?.user?.isCreate || user?.permissoes?.usuario?.cadastrar ? (
                                                            <Button type="button" onClick={() => navigate("/createPerfil", { state: { permissoes } } )}>
                                                                <AddIcon />
                                                            </Button>
                                                        )
                                                        :
                                                        (
                                                            <Button disabled={view} type="button" onClick={() => navigate("/createPerfil", { state: { permissoes } } )}>
                                                                <AddIcon />
                                                            </Button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <Card className="bodyCard">
                                <div className="bodyWork">
                                    <div className="rowTitle">
                                        <h5> Permissões de Acesso </h5>
                                    </div>

                                    <Permissions view={view} permissoes={permissoes} handleChange={handleChange} handleSelecionarTodosGeral={handleSelecionarTodosGeral} selecionarTodosGeral={selecionarTodosGeral} />
                                </div>

                            </Card>

                            {carregando ? (
                                <div className="spinner-border text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            ) : (
                                <div className="actionsBar">
                                    <Link to={"/userList"} className="actionsBack">
                                        <BackButton />
                                    </Link>
                                    <button disabled={view} onClick={id ? update : save} type="button" className="btn btn-primary btn-cadastrar">
                                        {id ? "Atualizar" : "Cadastrar"}
                                    </button>
                                </div>
                            )}
                        </div>


                        <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                            <DialogTitle id="alert-dialog-title">
                                <h1>
                                    <i className="fa fa-exclamation-triangle" style={{ color: "#FEDE00" }} aria-hidden="true" /> {title}
                                </h1>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    <h6>{msg}</h6>
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <button type="button" onClick={handleClose} className="btn btn-primary btn-cadastrar">
                                    Ok
                                </button>
                            </DialogActions>
                        </Dialog>

                        <CreateListPerfil open={showCreateModal} onClose={() => setShowCreateModal(false)} onSaveChange={() => setCarregando(true)} />
                    </div>
                }
            />
        </>
    );
}

export default NewUser;
